<template>
    <rkm-row>
        <rkm-col cols="6">
            <rkm-form-radio-group
                label="Jornadas controladas por"
                v-model="data.model.controleJornada"
                :validations="validations.controleJornada"
            >
                <rkm-form-radio :value="enums.tipoControleJornada.ATENDIMENTO">Atendimentos</rkm-form-radio>
                <rkm-form-radio
                    :value="enums.tipoControleJornada.EXAME"
                    :disabled="bloqueiaControlePorExame"
                >
                    Exames
                </rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="12" v-if="bloqueiaControlePorExame">
            <rkm-alert show color="warning">
                Desmarque o agendamento pelo APP Cidadão antes de alterar o controle de jornada para exames.
            </rkm-alert>
        </rkm-col>
    </rkm-row>
</template>

<script>

// Enuns.
import tipoControleJornada from '@/enums/exame-imagem/tipoControleJornada'

export default {
    computed: {
        validations() {

            return {
                controleJornada: { required: true},
            }
        },
        agendamentoAppHabilitado() {

            const integracao = this.data.model.integracaoAplicativo

            return integracao ? integracao.habilitaAgendamentoConectasusCidadao : false
        },
        bloqueiaControlePorExame() {

            return this.agendamentoAppHabilitado
                && this.data.model.controleJornada !== this.enums.tipoControleJornada.EXAME
        },
    },
    data: () => ({
        enums: {
            tipoControleJornada
        },
    }),
    props: {
        data: { type: Object, required: true },
    },
}
</script>